<script>
    import PolicyRow from "./PolicyRow.svelte";

    export let assessment_model;
    let assessment = assessment_model.store;
</script>

<table class="table is-fullwidth is-striped">
    <thead>
        <tr>
            <th width="350px">Policy Name</th>
            <th width="250px">Policy Provided</th>
            <th width="250px">RAG Status</th>
            <th>Recommendation</th>
        </tr>
    </thead>
    <tbody>
        {#each $assessment.assessment_type_data.policies || [] as policy (policy)}
            <PolicyRow policy_id={policy.policy_id} {assessment_model} />
        {/each}
    </tbody>
</table>